import React, { useState } from "react";
import {
  AllPlansButton,
  BuyButton,
  Card,
  CardBelow,
  CardGrid,
  CardTitle,
  MonthText,
  ProText,
  StyledBadge,
  SubTextStrike,
} from "../styledComponents";

import { Flex } from "rebass/styled-components";
import savePro from "../../../../Assets/Promotions/savePro.svg";
import savePlat from "../../../../Assets/Promotions/savePlat.svg";
import { useRecoilState, useSetRecoilState } from "recoil";
import { AllstarModalState } from "../../../../State/modals";
import { StorageAddonModalState } from "../../../../State";
import { ModalType } from "../../../../@types";
import { StyledPercentOffContainer } from "./styledComponents";
import { analytics } from "MVVM/Analytics";
import { UserBadge } from "MVVM/Components/UserBadge";
import { useShouldShowSubscriptionOverhaul } from "MVVM/Hooks/useSubscriptionOverhaul";

interface UpgradeCta {
  price: string;
  hasPromo: boolean;
  planName: string;
  planSubText: string;
  pcntOff?: string;
  PlanIcon: React.ElementType;
}

const getPcntOffSvg = (subTier: string) => {
  switch (subTier) {
    case "PRO":
      return savePro;
    case "CREATOR_PLAT":
      return savePlat;
    default:
      return savePro;
  }
};

export const UpgradeCta = () => {
  const [allstarModalState, setAllstarModalState] =
    useRecoilState(AllstarModalState);
  const setStorageAddonModal = useSetRecoilState(StorageAddonModalState);
  const showSubscriptionOverhaul = useShouldShowSubscriptionOverhaul();

  const requiredScope = allstarModalState?.data?.requiredScope;

  const [upgradeCtaState] = useState<UpgradeCta>(() => {
    switch (requiredScope) {
      case "ESSENTIALS":
        return {
          price: "0.99",
          hasPromo: false,
          planName: "Basic",
          planSubText: "MONTHLY PLAN STARTING FROM",
          PlanIcon: () => <UserBadge size="lg" userGroup="ESSENTIALS" />,
        };

      case "PRO":
        return {
          price: "5.99",
          hasPromo: false,
          planName: showSubscriptionOverhaul ? "Standard" : "Pro",
          planSubText: "MONTHLY PLAN STARTING FROM",
          PlanIcon: () => <UserBadge size="lg" userGroup="PRO" />,
        };

      case "CREATOR_PLAT":
        return {
          price: "24.99",
          hasPromo: false,
          planName: showSubscriptionOverhaul ? "Unlimited" : "Creator Platinum",
          planSubText: "MONTHLY PLAN STARTING FROM",
          PlanIcon: () => <UserBadge size="lg" userGroup="CREATOR_PLAT" />,
        };

      default:
        return {
          price: "5.99",
          hasPromo: false,
          planName: showSubscriptionOverhaul ? "Standard" : "Allstar Pro",
          planSubText: "MONTHLY PLAN STARTING FROM",
          PlanIcon: () => <UserBadge userGroup="PRO" />,
        };
    }
  });

  const openStorageModal = (plan?: string) => {
    setAllstarModalState({
      isOpen: ModalType.None,
      data: {},
      functions: {},
    });
    setStorageAddonModal({
      isOpen: true,
      analyticsSource: "Paywall",
      initialPlan: plan,
    });
  };

  return (
    <>
      <CardGrid flexDirection={"row"} flexWrap={"wrap"}>
        <Card>
          {upgradeCtaState?.pcntOff && (
            <>
              <StyledPercentOffContainer>
                {upgradeCtaState?.pcntOff}
              </StyledPercentOffContainer>
              <StyledBadge src={getPcntOffSvg(requiredScope)} />
            </>
          )}
          {
            <upgradeCtaState.PlanIcon
              style={{ width: "20px", height: "20px" }}
            />
          }
          <CardTitle>{upgradeCtaState.planName}</CardTitle>
          <SubTextStrike>{upgradeCtaState.planSubText}</SubTextStrike>
          <Flex alignContent="flex-end" alignItems="flex-end" mb={2}>
            <CardTitle>${upgradeCtaState.price}</CardTitle>
            <MonthText>/mo</MonthText>
          </Flex>

          <BuyButton
            onClick={(e) => {
              analytics.track("Paywall - Button Click", {
                type: "upgradeButton",
                feature: allstarModalState?.data?.type,
              });
              openStorageModal(requiredScope || "PRO");
              e.stopPropagation();
            }}
          >
            Upgrade
          </BuyButton>
        </Card>

        <CardBelow>
          <ProText>Remixes - Unlimited</ProText>
          <ProText>Mobile Clips - Unlimited</ProText>
          <ProText>Remove Watermarks</ProText>
        </CardBelow>
      </CardGrid>
      <AllPlansButton>
        <BuyButton
          onClick={() => {
            analytics.track("Paywall - Button Click", {
              type: "seeAllPlans",
              feature: allstarModalState?.data?.type,
            });
            openStorageModal();
          }}
          style={{
            background: "none",
            padding: 0,
            color: "inherit",
            textDecoration: "underline",
            fontSize: "inherit",
          }}
        >
          See all plans
        </BuyButton>
      </AllPlansButton>
    </>
  );
};
